export default {"src":"/_next/static/image/public/images/mounjaro_graphics.30d61bceb8f41cfb5a31c6a8f0630c39.svg","height":516,"width":403};